import React, { Fragment, useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";

//MUI
import Box from "@mui/material/Box";

//Custom Components
import ModelTable from "@/ui/Table/ModelTable";
import MapContext from "@/components/Map/MapContext";

import DialogContext from "@/ui/DialogContext/DialogContext";
import SnackbarContext from "@/ui/SnackbarContext/SnackbarContext";
import SidebarContext from "@/components/Map/Controls/Sidebar/SidebarContext/SidebarContext";
import { DCRecord, IDataController } from "@/@types/lib/dataController";

// OpenLayers
import OlFormatWKT from "ol/format/WKT";

export type DataPaneProps = {
  tableName: string,
  viewName: string,
  dc: IDataController,
  records: DCRecord[]
}

export default function DataPane(props: DataPaneProps) {
  const { t } = useTranslation();

  const mapContext = useContext(MapContext);
  const dialogContext = useContext(DialogContext);
  const snackbarContext = useContext(SnackbarContext);
  const sidebarContext = useContext(SidebarContext);

  const { dc, records, tableName, viewName } = props;

  const allowRowAction = (action: string, id: number) => {
    switch (action) {
      case "show_on_map":
        return true;
      case "avenza":
        const rec = records.find(x => x.id === id);
        if (rec && rec.avenza_map === true) {
          return true;
        } else {
          return false;
        }
      case "locus":
        const rec2 = records.find(x => x.id === id);
        if (rec2 && rec2.locus_map === true) {
          return true;
        } else {
          return false;
        }
      default:
        return true;
    }
  }

  const handleRowAction = (action: string, id: number) => {
    switch (action) {
      case "show_on_map":
        const rec = records.find(x => x.id === id);
        if (rec && rec.wkt) {
          const wktFormatter = new OlFormatWKT();
          const feat = wktFormatter.readFeature(rec.wkt, {
            dataProjection: "EPSG:3857",
            featureProjection: "EPSG:3857"
          })
          //console.log(feat);
          const extent = feat.getGeometry()?.getExtent();

          if (mapContext && mapContext.map) {
            const view = mapContext.map.getView();
            if (extent)
              view.fit(extent, { padding: [20, 20, 20, 220], duration: 500});
          }
        }
        break;
      case "avenza":
        //TODO: implement open in new page
        break;
      case "locus":
        //TODO: implement open in new page
        break;
    }
  }

  return (
    <Box m={0} p={0} style={{ height: 'calc(100% - 40px)' }}>
      <ModelTable
        dc={dc}
        title={''}
        tableName={tableName}
        records={records}
        allowSelection="none"
        allowAdd={false}
        allowFilter={false}
        allowColumnPicker={false}
        viewName={viewName}
        allowRowAction={allowRowAction}
        onRowAction={handleRowAction}
        initialPageSize={Array.isArray(records) ? records.length + 1 : undefined}
      />
    </Box>
  );
}
